<template>
	<v-app>
		<core-drawer />
		<core-toolbar />
		<core-view />
		<snack-alert />
		<snack-downloads v-if="this.$store.getters.getSnackDownload" />
	</v-app>
</template>

<script>
//import CoreToolbar from './components/core/Toolbar'
import WebsocketManager from "@/plugins/websocketManager";
export default {
	name: "ProjectsViewerIndex",
	components: {
		//CoreToolbar,
		CoreToolbar: () => import("@/components/core/Toolbar.vue"),
		CoreDrawer: () => import("@/components/core/Drawer.vue"),
		CoreView: () => import("@/components/core/View.vue"),
		SnackDownloads: () => import("./detailsView/components/SnackDownloads"),
		SnackAlert: () => import("@/components/base/SnackAlert"),
	},
	async mounted() {
		var Websocket;
		var user;
		if (!this.$store.getters.isAuthenticated) {
			user = await this.$store.dispatch("getUser");
			if (user) {
				this.$store.commit("userAuthenticated", user);
			} else this.$router.push("/redirect");
		} else {
			user = await this.$store.dispatch("getUser");
		}
		if (user) {
			let ws = this.$store.getters.getWebsocket;
			if (ws === undefined || !ws.isConnected()) {
				Websocket = new WebsocketManager(
					config.VUE_APP_NOTIFICATIONS + "?token=" + user.access_token,
					config.VUE_APP_WS_RECONNECT_TIME,
					config.VUE_APP_WS_DEBUG
				);
				Websocket.Connect();
				this.$store.commit("setWebsocket", Websocket);
			}
		}
	},

	data: () => ({}),
};
</script>
